import { MEMBank } from './../models/Commons/rfid/RFID';
import { Injectable, ChangeDetectorRef, NgZone } from "@angular/core";
import { Observable } from "rxjs";
import { PrintParam } from "./../models/Commons/rfid/Printer";
import { observer } from '../models/Commons/rfid/observer';

declare var $;

@Injectable()
export class RfidreaderService {
  observer: observer;
  private cmdNum = 1;
  constructor(private zone: NgZone) { }
  //获取浏览器服务
  private getBrowserService<T extends IBrowserService>(bsName: string) {
    if (window.hasOwnProperty(bsName) && window[bsName].isWork()) {
      return window[bsName] as T;
    } else {
      return null;
    }
  }

  //单次读取rfid标签
  public readRfid(): Observable<string> {
    var readerService = this.getBrowserService<BrowserRfidReaderService>(
      "bowserRfidReaderService"
    );
    return new Observable(observer => {
      const successHandler = e => observer.next(e);
      const errorHandler = e => observer.error(e);
      if (readerService == null) {
        $.ktoast("没有找到读卡器相关的服务", 500);
        errorHandler("没有找到读卡器相关的服务");
        return;
      }

      readerService.readRfid(epc => {
        this.zone.run(() => {
          successHandler(epc);
        });
      });
    });
  }

  //开始循环读卡
  public readRfidInterval(): Observable<string> {
    var readerService = this.getBrowserService<BrowserRfidReaderService>(
      "bowserRfidReaderService"
    );
    return new Observable(observer => {
      const successHandler = e => observer.next(e);
      const errorHandler = e => observer.error(e);
      if (readerService == null) {
        $.ktoast("没有找到读卡器相关的服务", 500);
        errorHandler("没有找到读卡器相关的服务");
        return;
      }
      readerService.readRfidInterval(epc => {
        this.zone.run(() => {
          successHandler(epc);
        });
      });
    });
  }
  //停止循环读卡
  public stopReadRfidInterval() {
    var readerService = this.getBrowserService<BrowserRfidReaderService>(
      "bowserRfidReaderService"
    );
    if (readerService == null) {
      $.ktoast("没有找到读卡器相关的服务", 500);
      return;
    }
    readerService.stopReadRfidInterval();
  }
  /**
  * 设置本地读卡指令回调函数
  *  callback 回调函数
  *  content  上下文
  */
  setCallback(callback: Function, content: any) {
    this.observer = new observer(callback, content);
  }
  onInventory(param: any) {
    var readerService = this.getBrowserService<BrowserRfidReaderService>(
      "bowserRfidReaderService"
    );
    if (readerService == null) {
      $.ktoast("没有找到读卡器相关的服务", 500);
      return;
    }
    readerService.readRfid(epc => {
      var jboj: any = {};
      var data: any = {};
      data.Bank = MEMBank[MEMBank.EPC];
      data.EPC = [];
      data.EPC.push(epc);
      jboj.CMD_Type = "RFID_CMD";
      jboj.CMD = "Inventory";
      jboj.Result = "True";
      jboj.CMD_Num = this.cmdNum;
      jboj.Data = JSON.stringify(data);
      if (this.observer)
        this.observer.Nofity(jboj);
      this.cmdNum++;
      return this.cmdNum - 1;
    });
  }
}
//浏览器服务接口
export interface IBrowserService {
  //是否在工作
  isWork(): boolean;
}

export interface BrowserRfidReaderService extends IBrowserService {
  readRfid(callback: Function); //读取一个标签
  readRfidInterval(callback: Function); //批量读取标签
  stopReadRfidInterval(); //关闭批量读取标签
}
